import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { SelectInputSmall } from 'Packages/FacetDesign/Components';
import { FDStat } from '@facet-wealth/design';

const TaxStrategyGainsBudgetCalculatorMetaOverride = buildFacetDesignOverride()
  .override({ hint: 'usd' },
    {
      _customProps: { labelPlacement: 'left' },
    },
    overrideReadOnly)
  .override({ hint: 'percent' },
    {
      _customProps: { labelPlacement: 'left' },
    },
    overrideReadOnly)
  .typeOverride('picklist',
    {
      _customProps: { labelPlacement: 'left', fullWidth: true, size: 'small' },
      _component: () => SelectInputSmall,
    },
    overrideReadOnly)
  .override({ readonly: true, type: 'string' }, {
    _component: () => FDStat,
  }, overrideReadOnly);

export default TaxStrategyGainsBudgetCalculatorMetaOverride;
